module.exports = __webpack_public_path__ + "static/media/author-image.3a48478f.jpg";